import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { roundOffAndFormatNumberWithCurrency } from '../../../../utils/utils'
import type { WithdrawDetail } from '../../types/recommendation.types'
import { getLogoUrl } from './FundCardLayout'
import { SaveTaxBookingRow } from './SaveTaxBookingRow'
import { useBottomSheet } from '../../../../state-management/contexts/BottomSheetContext'
import ExitLoadImpactBottomSheet from '../../bottom-sheets/ExitLoadImpactBottomSheet'

const ROW_ICON_SIZE = 'w-10 h-10'

type FolioRowProps = {
  detail: WithdrawDetail
  showBorderAbove?: boolean
  isFutureTax?: boolean
  isGains?: boolean
}

export function FolioRow({ detail, showBorderAbove, isFutureTax = true, isGains = true, }: FolioRowProps) {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()
  const withdrawFormatted = roundOffAndFormatNumberWithCurrency(detail?.withdrawAmount ?? 0)
  const currentValue = detail?.currentValue
  const totalFormatted = currentValue != null ? roundOffAndFormatNumberWithCurrency(currentValue) : null
  const saveTax = detail?.saveTax ?? 0
  const gainsAbs = Math.abs(detail?.gains ?? 0)
  const showSaveTaxBooking = saveTax !== 0 || gainsAbs !== 0
  const taxLabel = isFutureTax ? 'future tax' : 'tax'
  const gainLossLabel = isGains ? 'gains' : 'losses'
  return (
    <div
      className={`flex gap-3 items-stretch px-4 pt-4 pb-4 ${showBorderAbove ? 'border-t border-[#F0F4F7]' : ''}`}
    >
      <div className={`${ROW_ICON_SIZE} flex-shrink-0 overflow-hidden rounded-full bg-[#E8E8E8]`}>
        {detail?.brokerLogo ? (
          <img
            className="h-full w-full object-contain"
            src={getLogoUrl(detail.brokerLogo)}
            alt=""
          />
        ) : null}
      </div>
      <div className="flex flex-col min-w-0 flex-1 overflow-visible">
        <div className="text-[14px] font-[400] text-[#232323] leading-[130%]">
          {detail?.brokerName ?? ''}
        </div>
        <div className="text-[13px] font-[400] text-[#8E9393] leading-[150%] pt-0.5">
          Folio #{detail?.folioNumber ?? ''}
        </div>
        {showSaveTaxBooking && (
          <SaveTaxBookingRow
            saveTaxAmount={saveTax}
            bookAmount={gainsAbs}
            taxLabel={taxLabel}
            gainLossLabel={gainLossLabel}
          />
        )}
        {
          detail?.exitLoad > 0 && (
            <div
              onClick={() => {
                openBottomSheet(
                  <ExitLoadImpactBottomSheet onDismiss={closeBottomSheet} />,
                  closeBottomSheet
                )
              }}
              className="flex gap-2 mt-3 cursor-pointer overflow-visible w-max"
            >
              <div className="flex flex-col gap-0.5 text-[13px] font-[400] text-[#6A6E6E] 
              bg-grey80 px-2 py-1 rounded-md">
                <div className='flex flex-row items-center leading-[1.5] gap-1'>
                  Exit load of {roundOffAndFormatNumberWithCurrency(detail?.exitLoad ?? 0)} applicable
                  <RenderHTML innerHTMLText={InfoIcon} />
                </div>
              </div>
            </div>
          )
        }
      </div>
      <div className="flex-shrink-0 flex flex-col items-end justify-start text-right">
        <div className="text-[13px] font-[500] text-[#232323] leading-[130%]">
          {withdrawFormatted}
        </div>
        {totalFormatted != null && (
          <div className="text-[13px] font-[400] text-[#8E9393] leading-[150%] pt-0.5">
            of {totalFormatted}
          </div>
        )}
      </div>
    </div>
  )
}


const InfoIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
  <g clip-path="url(#clip0_73881_45083)">
    <path d="M6.00028 11.0513C8.78886 11.0513 11.0494 8.79081 11.0494 6.00223C11.0494 3.21369 8.78886 0.953125 6.00028 0.953125C3.21173 0.953125 0.951172 3.21369 0.951172 6.00223C0.951172 8.79081 3.21173 11.0513 6.00028 11.0513Z" stroke="#6A6E6E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4.83594 8.32812H7.16629" stroke="#6A6E6E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M5.99944 8.32812V5.60938H5.22266" stroke="#6A6E6E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.0067 3.86496C5.89945 3.86496 5.8125 3.77801 5.8125 3.67076C5.8125 3.56351 5.89945 3.47656 6.0067 3.47656" stroke="#6A6E6E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.00586 3.86496C6.11311 3.86496 6.20006 3.77801 6.20006 3.67076C6.20006 3.56351 6.11311 3.47656 6.00586 3.47656" stroke="#6A6E6E" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </g>
  <defs>
    <clipPath id="clip0_73881_45083">
      <rect width="12" height="12" fill="white"/>
    </clipPath>
  </defs>
</svg>`
